/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-04 16:39:18
 * @Explain: 自动化活动
 */

/** 提交类型 */
export enum SubmitTypeEnum {
  DEFAULT = 'default',
  SAVE = 'save',
  SAVE_ACTIVE = 'save-active',
}

/** 设置欢迎邮件方式 */
export enum WelcomeEmailMethodEnum {
  NO = 'false',
  YES = 'true',
}

// 联系人加入设置 选择项分类
export enum OptInSetGroupEnum {
  /** API */
  API = 'API',
  /** 注册表单 */
  SING_UP_FORM = 'signUpForm',
}

/** 多久执行 - 时间类型 */
export enum WaitTimeTypeEnum {
  /** 默认 */
  DEFAULT = 0,
  /** 按小时 */
  HOUR = 1,
  /** 按天 */
  DAY = 2,
  /** 按周 */
  WEEK = 3,
}
// 节点类型
export enum NodeTypeEnum {
  // 增加来源节点
  addSourceNode = 'addSourceNode',
  // 基础来源节点
  baseSourceNode = 'baseSourceNode',
  // 条件节点
  conditionNode = 'conditionNode',
  // trigger
  waitForTriggerNode = 'waitForTriggerNode',
  // sendEmail
  sendEmailNode = 'sendEmailNode',
  // 等待时间
  waitTimeNode = 'waitTimeNode',
}

// 表单类型
export enum AddSourceType {
  default = 0,
  /** API */
  api = 1,
  /** 注册表单 */
  form = 2,
  /** 标签 */
  tag = 3,
}
// 添加来源类型
export enum EditSourceNodeMode {
  'add' = 'add',
  'edit' = 'edit',
  'detail' = 'detail',
}

export enum JourneyNodeType {
  // 来源
  SOURCE = 'source',
  SOURCE_VALUE = 1,
  // 双重确认
  OPT_IN = 'optIn',
  OPT_IN_VALUE = 2,
  // 等待
  WAIT_PERIOD = 'waitingPeriod',
  WAIT_PERIOD_VALUE = 4,
  // 发送邮件
  SEND_EMAIL = 'sendEmail',
  SEND_EMAIL_VALUE = 3,
  // IF-ELSE 节点
  IF_ELSE = 'ifElse',
  IF_ELSE_VALUE = 5,
  // 增加来源节点：
  ADD_SOURCE = 'addSource',
  ADD_SOURCE_VALUE = 'addSourceValue',
  // 添加来源节点取-1
  ADD_SOURCE_CONFIRM_VALUE = -1,
  // 增加节点 - 发送/等待节点
  ADD_NODE = 'addNode',
  ADD_NODE_VALUE = 'addNodeValue',
  // 结束节点
  EXIT_NODE = 'exitNode',
  EXIT_NODE_VALUE = 'exitNodeValue',

  // 旅程设置
  JOURNEY_SETTINGS = 'journeySettings',
  JOURNEY_SETTINGS_VALUE = 6,

  // Wait for trigger
  WAIT_FOR_TRIGGER = 'waitForTrigger',
  WAIT_FOR_TRIGGER_VALUE = 7,

  // 傀儡节点 - 用于模仿一般的节点， 增加按钮
  DUMMY_NODE = 'dummyNode',
  DUMMY_NODE_VALUE = 'dummyNodeValue',
}

/** 节点状态 */
export enum JourneyNodeStatusEnum {
  /** 占位符不足，节点异常 */
  NODE_ANOMALY = 0,
  /** 未激活 */
  UN_ACTIVATED = 1,
  /** 进行中 */
  IN_PROGRESS = 2,
  /** 暂停 */
  PAUSE = 3,
  /** 终止 */
  TERMINATION = 4,
}

export enum TJourneyBaseNodeStatus {
  /** 创建状态 - 未激活状态 */
  CREATE = 'create',
  CREATE_VALUE = 1,
  /** 编辑状态 - 进行中状态 */
  UPDATE = 'update',
  UPDATE_VALUE = 2,
  /** 暂停状态 */
  PAUSED = 'paused',
  PAUSED_VALUE = 3,
}

/** 增加节点 - 分组类型 */
export enum AddNodeOptionGroupEnum {
  CONDITION = 'condition',
  RULE = 'rule',
}

export enum DeleteIfElseNodeOptions {
  KEEP_YES_PATH = 'KEEPYES',
  KEEP_NO_PATH = 'KEEPNO',
  DELETE_BOTH_PATH = 'DELETEBOTHPATH',
}

export enum IfElseEnum {
  IF_ELSE_YES_VALUE = '1',
  IF_ELSE_NO_VALUE = '0',
}

/** 节点流量控制 - 时间类型 */
export enum DateTypeEnum {
  /** 天 */
  EMAIL_FREQUENCY_DAY = 1,
  /** 周 */
  EMAIL_FREQUENCY_WEEK = 2,
  /** 月 */
  EMAIL_FREQUENCY_MONTH = 3,
}

/** 节点流量控制 - 每次发送间隔（单位s） */
export enum SendingIntervalEnum {
  /** 不设置 */
  NOT_SET = 0,
  /** 1分钟 */
  MINUTES_1 = 60,
  /** 5分钟 */
  MINUTES_5 = 300,
  /** 30分钟 */
  MINUTES_30 = 1800,
  /** 1小时 */
  HOUR_1 = 3600,
  /** 3小时 */
  HOUR_5 = 10800,
}

// 来源选项订阅状态过滤单选开关
export enum SourceSubTypeEnum {
  // 仅订阅：仅在用户完成订阅确认后进入旅程。
  ONLY_SUB = 0,
  // 忽略订阅：不区分订阅状态，联系人添加后立即进入旅程。
  IGNORE_SUB = 1,
  // 等待订阅 0
  WAIT_SUB = 0,
  // 直接通过 1
  DIRECT_ACCESS = 1,
}

/** 节点流量控制 - 时间类型 */
export enum DateTypeEnum {
  /** 天 */
  EMAIL_FREQUENCY_DAY = 1,
  /** 周 */
  EMAIL_FREQUENCY_WEEK = 2,
  /** 月 */
  EMAIL_FREQUENCY_MONTH = 3,
}

/** 节点流量控制 - 每次发送间隔（单位s） */
export enum SendingIntervalEnum {
  /** 不设置 */
  NOT_SET = 0,
  /** 1分钟 */
  MINUTES_1 = 60,
  /** 5分钟 */
  MINUTES_5 = 300,
  /** 30分钟 */
  MINUTES_30 = 1800,
  /** 1小时 */
  HOUR_1 = 3600,
  /** 3小时 */
  HOUR_5 = 10800,
}

// 旅程设置 - 再次进入旅程限制
export enum RepeatEntryEnum {
  // 允许联系人在离开旅程后多久再次进入旅程
  YES = 1,
  // 联系人不可重复进入旅程
  NO = 0,
}
// 旅程设置 - 等待时间单位
export enum ReentryWaitUnitEnum {
  // 分钟
  MINUTE = 1,
  // 小时
  HOUR = 2,
  // 天
  DAY = 3,
}

// 设置时间限制的最值
export enum TimeLimitNumberEnum {
  MIN = 1,
  MAX = 100,
}
export enum NodeInfo {
  // 节点高度
  HEIGHT = 146,
  // 不展示 描述信息时候的高度
  NOT_DESCRIPTION_HEIGHT = 100,
  // 普通节点宽度
  WIDTH = 400,
  // 退出节点宽度
  EXIT_WIDTH = 300,
}
